<template>
  <v-container>
    <v-row>
      <v-col cols='12'>
        <v-data-table :headers='headers' :items='itens' class='elevation-1' :search="search" :items-per-page="itemsPerPage" @update:items-per-page=" v => itemsPerPage = v">
          <template v-slot:top>
            <v-toolbar flat color='white'>
              <v-toolbar-title v-text="$t('keywords.listing')" />
              <v-divider class='mx-4' inset vertical></v-divider>
              <v-btn v-has-permission="['desenvolvedor']" color='primary' dark class='mb-2' @click="editItem(null)" v-text="$t('button.new')" />
              <ImportExportParameter @import="searchAll()" />
            </v-toolbar>
            <v-toolbar flat color='white'>
              <v-row>
                <SearchField v-model="parameterNameSearch" :label="$t('parameter.search.parameter')" />
                <SearchField v-model="parameterDescriptionSearch" :label="$t('parameter.search.description')" />
                <SearchField v-model="parameterValueSearch" :label="$t('parameter.search.value')" />
              </v-row>
            </v-toolbar>
          </template>
          <template v-slot:item.lastModified='{ item }'>
            <LastModify :date="item.lastModified" :by="item.lastModifiedBy"/>
          </template>
          <template v-slot:item.actions='{ item }'>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <v-icon v-on="on" color="orange" small class='mr-2' @click='editItem(item)'>mdi-pencil</v-icon>
              </template>
              <span>{{ $t('button.edit') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <v-icon v-has-permission="['desenvolvedor']" v-on="on" color="red" small class='mr-2' @click='deleteItem(item)'>mdi-delete</v-icon>
              </template>
              <span>{{ $t('button.delete') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <v-icon v-on="on" color="secondary" small class='mr-2' @click='exportItem(item)'>mdi-export</v-icon>
              </template>
              <span>{{ $t('core.import_export.export') }}</span>
            </v-tooltip>
          </template>
          <template v-slot:no-data>
            {{ $t('warnings.no_data_found') }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Servico from '@/services/ParameterService'
import ImportExportService from '@/services/ImportExportService'
import IncludesIgnoreCase from '../../utils/IncludesIgnoreCase'
import LastModify from '../core/LastModify.vue'
import SearchField from '../core/SearchField.vue'
import ImportExportParameter from './ImportExportParameter.vue'

export default {
  name: 'ParameterGrid',

  components: {
    LastModify,
    SearchField,
    ImportExportParameter
  },

  data: () => ({
    search: '',
    parameterNameSearch: '',
    parameterDescriptionSearch: '',
    parameterValueSearch: '',
    itens: []
  }),

  computed: {
    version () { return this.$versionable.versions.parameters },
    itemsPerPage: {
      get () {
        return this.$cookies.isKey('parameter_per_page') ? parseInt(this.$cookies.get('parameter_per_page')) : 10
      },
      set (value) {
        this.$cookies.set('parameter_per_page', value)
      }
    },
    headers () {
      return [
        {
          text: this.$t('parameter.param.name'),
          value: 'parameterName',
          sortable: true,
          align: 'start',
          filter: parameterName => IncludesIgnoreCase(parameterName, this.parameterNameSearch)
        },
        {
          text: this.$t('keywords.last_modify'),
          value: 'lastModified',
          sortable: true,
          show: this.version > '1.0.0'
        },
        {
          text: this.$t('parameter.param.description'),
          value: 'parameterDescription',
          sortable: true,
          align: 'start',
          filter: parameterDescription => IncludesIgnoreCase(parameterDescription, this.parameterDescriptionSearch)
        },
        {
          text: this.$t('parameter.param.value'),
          value: 'parameterValue',
          sortable: true,
          align: 'start',
          filter: parameterValue => IncludesIgnoreCase(parameterValue, this.parameterValueSearch)
        },
        {
          text: this.$t('keywords.actions'),
          value: 'actions',
          sortable: false
        }
      ].filter(h => h.show ?? true)
    }
  },

  mounted () {
    this.searchAll()
  },

  methods: {

    searchAll () {
      Servico.findAll()
        .then((result) => (this.itens = result.data))
    },

    editItem (item) {
      this.$emit('editItem', false, item)
    },

    deleteItem (item) {
      if (confirm(this.$t('warnings.confirm.delete'))) {
        Servico.delete(item)
          .then(() => this.searchAll())
          .catch((error) => this.$message.error(`${this.$t('warnings.error.delete')} : ${error}`))
      }
    },

    exportItem (item) {
      if (confirm(this.$t('warnings.confirm.export'))) {
        ImportExportService.export('parameter', item.parameterName)
          .then(() => this.$message.success(this.$t('warnings.success.export')))
          .catch(error => this.$message.error(`${this.$t('warnings.error.export')} : ${error}`))
      }
    }
  }

}
</script>
